import html2canvas from 'html2canvas'
import { downloadCSV } from 'modules/BioriskMpox/Epidemiology/helpers'
import { useCallback, useRef } from 'react'
import { FiltersT } from '..'
import { getCountryName } from '../getCountryName'
import { parseDate } from '../helpers'
import useTracking from 'tracking/useTracking'

export const useOnDownload = (data: any, filters: FiltersT, title: string) => {
  const [tracking] = useTracking()

  return useCallback(() => {
    const filteredData = data.filter(
      (x: any) =>
        parseDate(x.date_start) >= new Date(filters.dateRange.start) &&
        parseDate(x.date_end) <= new Date(filters.dateRange.end)
    )

    const headers = [
      'Country Code',
      'Country',
      'Area ID',
      'Date Start',
      'Date End',
      'Disease',
      'Value',
    ].join(',')

    const csvRows = filteredData.map((row: any) => {
      return [
        row.country_alpha_3,
        getCountryName(row.country_alpha_3),
        row.area,
        row.date_start,
        row.date_end,
        row.disease_name,
        row.value,
      ].join(',')
    })

    const fileName = `${title}_${filters.dateRange.start}_${filters.dateRange.end}.csv`
    tracking.downloadCsv({ file: fileName })
    downloadCSV(headers, csvRows, fileName)
  }, [data, filters.dateRange.end, filters.dateRange.start, title, tracking])
}

export const useOnDownloadImg = (fileName: string, fileType?: 'image/png') => {
  const ref = useRef<any>(null)
  const [tracking] = useTracking()

  const onDownloadImage = useCallback(() => {
    ;(async () => {
      const canvas = await html2canvas(ref.current!, {
        scale: 2,
        logging: true,
        ignoreElements: (x) => x.classList.contains('ignore-download'),
      })
      const imgData = canvas.toDataURL(fileType)
      const link = document.createElement('a')
      link.href = imgData
      link.download = fileName
      tracking.downloadPng({ file: fileName })
      link.click()
    })()

    return
  }, [fileName, fileType, tracking])

  return { ref, onDownloadImage }
}
